import React from 'react';
import { clearTokens } from '../utils/auth';
import { useNavigate } from 'react-router-dom';

const Logout: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    clearTokens();
    navigate('/login', { replace: true });
  }, [navigate]);

  return (
    <div style={{ padding: '24px' }}>Logging out...</div>
  );
};

export default Logout;


